import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import RouterConstants from "../constants/RouterConstants";
import { getSelectedOrganization } from "../helpers/localStorage";
import useSecureNavigate from "../hooks/useSecureNavigate.tsx";
import { useAppStore } from "../hooks/useStores.tsx";
import { isAdsEditor } from "../utils/index.ts";
import Container from "./Container";
import Provider from "./Provider";
import DesignEditor from "./views/DesignEditor";

const BriaDesignEditor = (props: { isPopupView?: boolean }) => {
	const navigate = useSecureNavigate();
	const { uiStore, campaignStore, brandsDefinitionStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "editor" });
	// TODO: This useEffect ensures that users cannot access the campaign editor without selecting an organization.
	// Once Ori opens a ticket to handle user access to campaigns without an organization, this useEffect can be removed.
	useEffect(() => {
		if (!getSelectedOrganization()?.organization.uid) {
			navigate(RouterConstants.CONSOLE.fullPath);
			return;
		}
		uiStore.hideSideBar();
		campaignStore.isBrandTemplateEditor = true;
		if (location.pathname.startsWith(RouterConstants.ADS_EDITOR.fullPath)) {
			campaignStore.isBrandTemplateEditor = false;
			uiStore.showBackButton(
				RouterConstants.APPS.path,
				undefined,
				t("backBtn"),
				undefined,
				undefined,
				undefined,
				t("adsEditor"),
			);
		} else if (location.pathname.startsWith(RouterConstants.ADS_GENERATOR.fullPath)) {
			uiStore.showBackButton(
				RouterConstants.APPS.path,
				undefined,
				t("backBtn"),
				undefined,
				undefined,
				undefined,
				t("adsGenerator"),
			);
		} else if (location.pathname.startsWith(RouterConstants.ADS_GENERATION.DEMO.BRANDS_TEMPLATES_EDITOR.fullPath)) {
			uiStore.showBackButton(
				RouterConstants.ADS_GENERATION.OVERVIEW.fullPath,
				undefined,
				t("backToAdsGenerationHub"),
			);
		} else {
			if (location.pathname.startsWith(RouterConstants.ADS_GENERATION.DEMO.ADS_EDITOR.fullPath)) {
				campaignStore.isBrandTemplateEditor = false;
			}
			uiStore.showBackButton(RouterConstants.ADS_GENERATION.DEMO.fullPath);
		}

		if (campaignStore.brandToDisplayInEditor && isAdsEditor()) {
			brandsDefinitionStore.setProperty("globalSelectedBrand", campaignStore.brandToDisplayInEditor);
		}
		return () => {
			uiStore.hideBackButton();
			uiStore.showSideBar();
			campaignStore.handleSetSelectedTemplate(null);
			if (!props.isPopupView) {
				campaignStore.setProperty("isFromAdsGenerator", false);
				campaignStore.setProperty("brandToDisplayInEditor", undefined);
				campaignStore.setProperty("isLoadingScenesInAdsEditor", false);
			}
		};
	}, []);

	return (
		<Provider isPopupView={props.isPopupView}>
			<Container>
				<DesignEditor isPopup={props.isPopupView} />
			</Container>
		</Provider>
	);
};

export default BriaDesignEditor;
